import { IAppState } from 'shared/common/state';

export const chatAnimationCounterSelector = (state: IAppState): number => {
  return state.consultantCianChat.chatAnimationCounter;
};
